.root {
  display: flex;
  flex-direction: column;
  gap: var(--bc-margin-sm, 12px);
  font-family: var(--bc-font-family);
}

.bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--bc-margin-sm, 12px);
  min-height: 32px;
}

.leading,
.trailing {
  display: flex;
  align-items: center;
  gap: var(--bc-margin-xs, 8px);
}

.gateOverlay {
  position: relative;
  pointer-events: none;
  opacity: 0.6;
}

.clearAllButton {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--bc-color-text-secondary, #5A7494);
  font-size: var(--bc-font-size, 14px);
  padding: 4px 8px;

  &:hover {
    color: var(--bc-color-primary, #0092FF);
  }
}
